import { createSlice } from "@reduxjs/toolkit";

export interface ArticlePageSlice {
    testFlag: boolean
}

const initialState: ArticlePageSlice = {
    testFlag: false
}

const articlePageSlice = createSlice({
  name: "articlePageSlice",
  initialState,
  reducers: {
    flipTestFlag: (state) => {
      state.testFlag = true
    }
  },
});

export const {
  flipTestFlag
} = articlePageSlice.actions;

export const articlePageReducer = articlePageSlice.reducer